import RewardList from 'components/Content/RewardList/RewardList';
import RewardListConnect from 'components/Content/RewardList/RewardList.connect';

export default RewardListConnect(RewardList);
